import gsap from "gsap";
import { MotionPathPlugin } from "gsap/MotionPathPlugin";

gsap.registerPlugin(MotionPathPlugin);

export const flyToCart = (
  startEl: HTMLElement,
  endEl: HTMLElement,
  onDone?: () => void
) => {
  const startRect = startEl.getBoundingClientRect();
  const endRect = endEl.getBoundingClientRect();

  // Create a circle element
  const circle = document.createElement("div");
  circle.style.position = "fixed";
  circle.style.width = "30px";
  circle.style.height = "30px";
  circle.style.borderRadius = "50%";
  circle.style.backgroundColor = "#75552E";
  circle.style.pointerEvents = "none";
  circle.style.zIndex = "1000";
  circle.style.top = "0";
  circle.style.left = "0";

  document.body.appendChild(circle);

  // Starting position
  const startX = startRect.right - 10;
  const startY = startRect.top;
  gsap.set(circle, { x: startX, y: startY, scale: 1, opacity: 1 });

  // Ending position
  const endX = endRect.left + endRect.width / 2;
  const endY = endRect.top + endRect.height / 2;

  // Animate along a curve
  gsap.to(circle, {
    duration: 0.8,
    x: endX,
    y: endY,
    scale: 0.4,
    opacity: 0,
    ease: "power1.inOut",
    motionPath: {
      path: [
        { x: startX, y: startY },
        { x: (startX + endX) / 2, y: startY - 80 }, // control point for arc
        { x: endX, y: endY },
      ],
      curviness: 1.2,
    },
    onComplete: () => {
      circle.remove();
      onDone?.();
    },
  });
};
